module.exports = __webpack_public_path__ + "img/20220223_155914.6bac0f83.jpg";